import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import { thunk } from 'redux-thunk';
import { version } from 'react';
import coursesReducer from './courseSlice'

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  blacklist: ['courses'], 
}

const reducer = combineReducers({
  auth: authReducer,
  courses: coursesReducer,
})

const persistedReducer = persistReducer(persistConfig, reducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false })

});

export default store;
